// extracted by mini-css-extract-plugin
module.exports = {"content":"aee5b7c44e--content--yngR4","description":"aee5b7c44e--description--e5aNq","list":"aee5b7c44e--list--gWjVQ","list-item":"aee5b7c44e--list-item--EOGrV"};